import { parseDMY } from "@/components/DateInput";

const MONTH_NAMES = { jan: 1, feb: 2, peb: 2, mar: 3, apr: 4, mei: 5, may: 5, jun: 6, jul: 7, agu: 8, agt: 8, aug: 8, sep: 9, okt: 10, oct: 10, nov: 11, nop: 11, des: 12, dec: 12 };

const NUMERIC = /(\d{1,2})\s*[/.\-\s]\s*(\d{1,2})\s*[/.\-\s]\s*(\d{4}|\d{2})(?!\d)/;
const NAMED = /(\d{1,2})[\s.\-/]*([a-zA-Z]{3,})\.?[\s.\-/,]*(\d{4}|\d{2})(?!\d)/;
// Excel rows: dates may be glued to other cells, e.g. "X230523118/04/196027/06/2033"
const GLUED_DATE = /(\d{2})[/.\-](\d{2})[/.\-](\d{4})/g;
const ROW_START = /(?:^|\n|(?<=\d{2}[/.\-]\d{2}[/.\-]\d{4}))[ \t]*(\d{1,3})[ \t]*(?=[A-Za-z])/g;

const pad = (n) => String(n).padStart(2, "0");
const fullYear = (y) => (y.length === 2 ? 2000 + Number(y) : Number(y));
const toValue = (d, m, y) => {
  const value = `${pad(d)} ${pad(m)} ${fullYear(y)}`;
  return parseDMY(value) ? value : null;
};

const findDate = (line) => {
  let m = line.match(NUMERIC);
  let month;
  if (m) {
    month = Number(m[2]);
  } else {
    m = line.match(NAMED);
    if (!m) return null;
    month = MONTH_NAMES[m[2].slice(0, 3).toLowerCase()];
    if (!month) return null;
  }
  const value = toValue(Number(m[1]), month, m[3]);
  return value ? { value, raw: m[0] } : null;
};

const cleanName = (s) => s.replace(/^\s*\d{1,3}\s*[.)\-:]?\s*/, "").replace(/[\t|;,:\-–]+/g, " ").replace(/\s{2,}/g, " ").trim();

const parseLines = (text) => {
  const rows = [];
  const failed = [];
  text.split("\n").map((l) => l.trim()).filter(Boolean).forEach((line) => {
    const date = findDate(line);
    if (!date) failed.push(line);
    else rows.push({ name: cleanName(line.replace(date.raw, " ")), exp: date.value });
  });
  return { rows, failed };
};

// Latest date in the row = passport expiry (earlier ones are e.g. date of birth)
const latestDate = (chunk) => {
  const dates = [...chunk.matchAll(GLUED_DATE)].map((m) => toValue(Number(m[1]), Number(m[2]), m[3])).filter(Boolean);
  const key = (v) => v.split(" ").reverse().join("");
  return dates.sort((a, b) => key(b).localeCompare(key(a)))[0] || null;
};

const rowName = (body) => {
  if (body.includes("\t")) return body.split(/[\t\n]/)[0].trim();
  const name = (body.match(/^[A-Za-z][A-Za-z .,'\-]*/) || [""])[0].trim();
  // Without tabs the gender cell (F/M/L/P) is glued to the name
  return name.replace(/(?<=[A-Za-z])[FMLP]$/, "").trim();
};

const parseExcelRows = (text) => {
  const starts = [...text.matchAll(ROW_START)];
  const rows = [];
  const failed = [];
  starts.forEach((m, i) => {
    const bodyStart = m.index + m[0].length;
    const chunk = text.slice(bodyStart, i + 1 < starts.length ? starts[i + 1].index : text.length);
    const name = rowName(chunk);
    const exp = latestDate(chunk);
    if (exp) rows.push({ name, exp });
    else failed.push(`${m[1]} ${name}`.trim());
  });
  return { rows, failed };
};

export const parsePastedList = (raw) => {
  const text = raw.replace(/\r/g, "").replace(/"/g, "").trim();
  const excel = parseExcelRows(text);
  const lines = parseLines(text);
  return excel.rows.length >= lines.rows.length && excel.rows.length ? excel : lines;
};
